// extracted by mini-css-extract-plugin
export default {"pageContainer":"app_pageContainer__EApCK","footer":"app_footer__8rBUW","card":"app_card__I87Iz"};